<style lang="less" scoped>
.legalPersonThree {
  width: 100%;
  min-height: 100%;
  padding-bottom: 20px;
  background-color: #f0f2f6;
  .roof {
    width: 100%;
    height: 100px;
    line-height: 100px;
    text-align: left;
    padding-left: 20px;
    box-sizing: border-box;
    background-color: #21aaff;
    font-size: 30px;
    color: #fff;
    display: flex;
    align-items: center;
    svg {
      margin-right: 20px;
    }
  }
  .header {
    width: 100%;
    background: url("data:image/png;base64,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");
    background-size: 100% 100%;
    .tabs {
      width: 692px;
      height: 153px;
      margin: 0 auto;
      background: rgba(255, 255, 255, 1);
      border-radius: 20px;
      display: flex;
      .item {
        flex: 1;
        text-align: center;
        font-size: 26px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        padding-top: 35px;
        box-sizing: border-box;
        position: relative;
        img {
          width: 52px;
          height: 52px;
        }
        .jiantou {
          width: 15px;
          height: 26px;
          position: absolute;
          right: 0;
          bottom: 30px;
        }
      }
      .item:last-child {
        color: #21aaff;
      }
    }
  }
  .Three {
    margin-top: 30px;
    width: 100%;
    // margin: 0 auto;
    // height: 617px;
    padding: 30px;
    box-sizing: border-box;
    background-color: #fff;
    overflow: hidden;
    .name {
      font-size: 30px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    .items {
      width: 525px;
      margin: 30px auto;
      display: flex;
      font-size: 22px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      div {
        flex: 1;
        text-align: center;
        img {
          width: 113px;
          height: 90px;
          margin-bottom: 20px;
          // border: 1px solid #ccc;
        }
        div {
          display: flex;
          align-items: center;
          justify-content: center;
          i {
            margin-right: 10px;
          }
        }
      }
    }
    .bankCard {
      width: 100%;
      margin: 0 auto;
      padding: 30px 50px 40px;
      overflow: hidden;
      box-sizing: border-box;
      .listLeft {
        // float: left;
        width: 284px;
        height: 221px;
        border: 1px solid #21aaff;
        border-radius: 10px;
        overflow: hidden;
        margin: 0 auto;
      }
      .listRight {
        float: right;
        width: 284px;
        height: 221px;
        border: 1px solid #21aaff;
        border-radius: 10px;
        overflow: hidden;
      }
      img {
        width: 100%;
        height: 100%;
        cursor: pointer;
      }
    }
  }
  .agreement {
    margin-top: 25px;
    width: 100%;
    text-align: center;
    font-size: 22px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(102, 102, 102, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    .but {
      span {
        // display: inline-block;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background-color: #fff;
        border: 1px solid #333;
        margin-right: 5px;
        margin-top: 4px;
        display: flex; //flex布局
        justify-content: center; //使子项目水平居中
        align-items: center; //使子项目垂直居中
        i {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #333;
        }
      }
    }
    span {
      color: #1dadff;
    }
  }
  .nextStep {
      width: 9.093333rem;
    height: 1.253333rem;
    margin: 0 auto;
    padding-top: 40px
    // line-height: 94px;
    // margin-top: 35px;
    // text-align: center;
    // background: rgba(33, 170, 255, 1);
    // border-radius: 20px;
    // font-size: 36px;
    // font-family: MicrosoftYaHei;
    // font-weight: 400;
    // color: rgba(255, 255, 255, 1);
  }
  .protocolText {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.65);
    color: #fff;
    overflow-y: auto;
    padding: 35px 50px;
    box-sizing: border-box;
    line-height: 45px;
    z-index: 9999;
    text-align: left;
    .title {
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 54px;
      text-align: center;
    }
    .name {
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 90px;
    }
    .haveRead {
      width: 80%;
      margin: 0 auto;
      margin-top: 55px;
      height: 90px;
      line-height: 90px;
      text-align: center;
      font-size: 36px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      background-color: #53b7f6;
    }
  }
  .main {
    width: 100%;
    // margin: 0 auto;
    margin-top: 30px;
    border-radius: 20px;
    padding: 35px;
    box-sizing: border-box;
    background-color: #fff;
    .main-input {
      width: 100%;
      height: 87px;
      line-height: 87px;
      border-bottom: 1px solid rgba(219, 219, 219, 1);
      font-size: 28px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      .main-code {
        float: right;
        width: 150px;
        height: 60px;
        background-color: rgba(33, 170, 255, 1);
        color: #fff;
        line-height: 60px;
        text-align: center;
        font-size: 24px;
        border-radius: 8px;
        margin-top: 13px;
      }
      .main-code1 {
        float: right;
        width: 150px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        font-size: 24px;
        border-radius: 8px;
        margin-top: 13px;
      }
      input {
        float: right;
        width: 80%;
        height: 100%;
        font-size: 26px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
      }
      input::-webkit-input-placeholder {
        /* WebKit browsers */
        color: rgba(153, 153, 153, 1);
      }
      input:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: rgba(153, 153, 153, 1);
      }
      input::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: rgba(153, 153, 153, 1);
      }
      input:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: rgba(153, 153, 153, 1);
      }
    }
  }
}
</style>

<style>
.legalPersonThree .listLeft .nut-imagepicker .img-list .add-icon {
  width: 284px;
  height: 221px;
  position: relative;
  border: none;
  background: url("https://gsb-zc.oss-cn-beijing.aliyuncs.com//zc_47515910923103332020218510333yhkz.png")
    no-repeat;
  background-size: 100% 100%;
}
.legalPersonThree .listRight .nut-imagepicker .img-list .add-icon {
  width: 284px;
  height: 221px;
  position: relative;
  border: none;
  background: url("https://gsb-zc.oss-cn-beijing.aliyuncs.com//zc_170515910923346242020218534624yhkf.png")
    no-repeat;
  background-size: 100% 100%;
}
.legalPersonThree .nut-imagepicker .img-list .img-item a img {
  display: inline-block;
  width: 284px;
  height: 221px;
}
.legalPersonThree .nut-imagepicker .img-list .add-icon i {
  display: none;
}
.legalPersonThree .nut-button.block {
  height: 70px !important;
  font-size: 30px !important;
  background: #21aaff;
}
.legalPersonThree .nut-button[disabled] {
  background: #dadada !important;
  color: #f6f6f6 !important;
}
.legalPersonThree .nut-textinput input {
  height: 80px !important;
}
.legalPersonThree .nut-textinput-label {
  font-size: 28px !important;
}
</style>

<template>
  <div class="legalPersonThree">
    <div class="roof" @click="back">
      <svg
        t="1591005918644"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="1100"
        width="20"
        height="20"
      >
        <path d="M511.609097 961.619254" p-id="1101" fill="#ffffff"></path>
        <path
          d="M360.749204 511.010463 360.749204 511.010463l382.080022-382.074905c14.762215-14.788821 14.762215-38.777165 0-53.585429-14.812357-14.788821-38.799678-14.788821-53.607942 0L283.415908 481.201553c-1.107217 0.867764-2.190899 1.824555-3.206018 2.843768-14.788821 14.808264-14.788821 38.795585 0 53.585429l408.226518 408.230612c14.808264 14.807241 38.795585 14.807241 53.584406 0 14.785751-14.767332 14.785751-38.754652 0-53.562916L360.749204 511.010463 360.749204 511.010463zM360.749204 511.010463"
          p-id="1102"
          fill="#ffffff"
        ></path></svg
      >银行信息填写
    </div>
    <div class="header">
      <div class="tabs">
        <div class="item" v-for="(o, i) in tabsArr" :key="i">
          <img :src="o.icon" alt="" />
          <div>{{ o.name }}</div>
          <img
            v-if="i == 0"
            class="jiantou"
            src="/static/images/fanhui-251.png"
            alt=""
          />
          <img
            v-if="i == 1"
            class="jiantou"
            src="/static/images/fanhui-251.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="Three">
      <div class="name">上传银行卡</div>
      <div class="bankCard">
        <div class="listLeft">
          <nut-imagepicker
            width="null"
            height="null"
            @imgMsg="yinhangka"
            :max="1"
          >
          </nut-imagepicker>
          <!-- <img :src="yhkz ? yhkz : '/static/images/yhkz.png'" alt=""> -->
        </div>
        <!-- <div class="listRight">
          <nut-imagepicker 
            width="null"
            height="null"
            @imgMsg="yinhangka1"
            :max="1"
          >
          </nut-imagepicker> -->
        <!-- <img :src="yhkf ? yhkf : '/static/images/yhkf.png'" alt=""> -->
        <!-- </div> -->
      </div>
      <div class="name">*拍摄须知</div>
      <div class="items">
        <div v-for="(item, key) in shootingArr" :key="key">
          <img :src="item.img" alt="" />
          <div>
            <nut-icon :type="item.icon" :color="item.color"> </nut-icon>
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <!-- <div class="main-input"> -->
      <!-- <span>开户行</span><input type="text" v-model="bank_name" maxlength="100" placeholder="请填写开户行名称"> -->
      <!-- <nut-textinput 
            v-model="bank_name"
            label="开户行"
            placeholder="请填写开户行名称"
            :has-border="false"
            :clearBtn="true"
            :disabled="false"
        />
      </div> -->
      <div class="main-input">
        <!-- <span>银行卡号</span><input type="text" v-model="bank_no" maxlength="30" placeholder="请填写银行卡号"> -->
        <nut-textinput
          v-model="bank_no"
          label="银行卡号"
          placeholder="请填写银行卡号"
          :has-border="false"
          :clearBtn="true"
          :disabled="false"
        />
      </div>
      <div class="main-input">
        <!-- <span>手机号</span> -->
        <!-- <div
          class="main-code"
          :style="'background-color:' + color"
          v-if="bank_mobile"
          @click="noteSend"
        >
          {{ noteType ? noteTime : "获取验证码" }}
        </div> -->
        <div class="main-code1"></div>
        <!-- <input type="text" style="width:calc(80% - 150px);" v-model="bank_mobile" maxlength="11" placeholder="请填写银行预留手机号"> -->
        <nut-textinput
          v-model="bank_mobile"
          maxlength="11"
          label="手机号"
          placeholder="请填写银行预留手机号"
          :has-border="false"
          :clearBtn="true"
          :disabled="false"
        />
      </div>
      <!-- <div class="main-input"> -->
      <!-- <span>验证码</span><input type="text" v-model="note_code" maxlength="11" placeholder="请填写短信验证码"> -->
      <!-- <nut-textinput
          v-model="note_code"
          label="验证码"
          placeholder="请填写短信验证码"
          :has-border="false"
          :clearBtn="true"
          :disabled="false"
        />
      </div> -->
    </div>

    <!-- <div class="agreement"> -->
    <!-- <i-icon type="circle" size="16" v-if="!consentType" style="margin-right: 8px;" />
      <i-icon type="success" size="16" v-if="consentType" color="#1DADFF" style="margin-right: 8px;" /> -->
    <!-- <div class="but" @click="consent"><span><i v-if="consentType"></i></span></div>
      已阅读并同意<span @click="protocol">《个体宝平台注册协议》</span> -->
    <!-- </div> -->

    <div class="nextStep">
      <nut-button block shape="circle" @click="nextStep"> 提交 </nut-button>
    </div>
    <div class="protocolText" v-if="protocolType">
      <registeredAgreement></registeredAgreement>
      <div class="haveRead" @click="haveRead">已阅读</div>
    </div>
  </div>
</template>

<script>
import http from "../../api/index.js";
import config from "../../utils/config.js";
import registeredAgreement from "@/components/registeredAgreement";

export default {
  data() {
    return {
      shootingArr: [
        {
          img: "/static/images/sicon1.png",
          name: "标准拍摄",
          icon: "tick",
          color: "#32C3A9",
        },
        {
          img: "/static/images/sicon2.png",
          name: "边框缺失",
          icon: "cross",
          color: "#FF3A1A",
        },
        {
          img: "/static/images/sicon1.png",
          name: "照片模糊",
          icon: "cross",
          color: "#FF3A1A",
        },
        {
          img: "/static/images/sicon4.png",
          name: "闪光强烈",
          icon: "cross",
          color: "#FF3A1A",
        },
      ],
      tabsArr: [
        { icon: "/static/images/icon-test-51.png", name: "个人信息" },
        // {icon:'/static/images/gongsi1.png',name:'公司信息'},
        { icon: "/static/images/yinxingqia-3.png", name: "银行卡" },
      ],
      consentType: false,
      yhkz: null,
      yhkf: null,
      bankCardIsImg: null,
      bankCardTheImg: null,
      protocolType: false,
      bank_name: null,
      bank_no: null,
      bank_mobile: null,
      note_code: "",
      noteType: false,
      noteTime: 60,
      color: "rgba(33,170,255,1)",
      legalData: {},
      data: {
        d: {},
        action: "",
      },
    };
  },
  components: {
    registeredAgreement: registeredAgreement,
  },
  mounted() {
    this.legalData = JSON.parse(sessionStorage.getItem("legalData"));
      if(sessionStorage.getItem("esignappsid")){
     this.saasorderbusinessmenPagePost();
  }
  
  },
  methods: {
      saasorderbusinessmenPagePost() {
      http.post(config.signInfo).then((e) => {
        // console.log(e,'个体户详情')
        if (e.code == 0) {
           this.bank_no = e.data.bankNo;
           this.bank_mobile = e.data.mobile;
        }
      });
    },
    back() {
      this.$router.go(-1); //返回上一层
    },
    // 发送验证码
    noteSend() {
      console.log("?????????????????");
      if (this.noteType) {
        return;
      }

      if (!/^(1[0-9])\d{9}$/.test(this.bank_mobile)) {
        this.$toast.warn("联系手机格式错误");
        return;
      }
      this.sendCode();
      http
        .post(config.bindCardSendSms, {
          mobile: this.bank_mobile,
          bankNo: this.bank_no,
        })
        .then((e) => {
          if (e.code == 0) {
            // console.log(e);
            this.$toast.success("已发送验证码");
          } else {
            this.$toast.warn(e.message);
          }
        });
    },
    sendCode(e) {
      let that = this;
      this.noteTime = 60;
      let i = setInterval(() => {
        that.noteTime--;
        if (that.noteTime == 0) {
          (that.color = "rgba(33,170,255,1)"),
            (that.noteType = false),
            clearInterval(i);
        } else {
          (that.color = "#ccc"), (that.noteType = true);
        }
      }, 1000);
    },
    protocol() {
      this.protocolType = true;
    },
    haveRead() {
      this.protocolType = false;
      this.consentType = true;
    },
    nextStep() {
      // if (!this.bankCardIsImg) {
      //   this.$toast.warn("请上传银行卡正面");
      //   return;
      // }
      // if(!this.bankCardTheImg) {

      //   this.$toast.warn('请上传银行卡反面');
      //   return;
      // }

      // if(!this.consentType) {

      //   this.$toast.warn('请同意个体工商户注册委托协议');
      //   return;
      // }

      // if(!this.bank_name) {

      //   this.$toast.warn('请填写开户行名称');
      //   return;
      // }

      if (!this.bank_no) {
        this.$toast.warn("请填写银行卡号");
        return;
      }

      if (!this.bank_mobile) {
        this.$toast.warn("请填写银行预留手机号");
        return;
      }

      // if (!this.note_code) {
      //   this.$toast.warn("请填写短信验证码");
      //   return;
      // }

      // if(this.note_code != this.nodeCode) {
      //   wx.showToast({title: '短信验证码不正确', icon: 'none', duration: 2000});
      //   return;
      // }

      if (!/^(1[0-9])\d{9}$/.test(this.bank_mobile)) {
        this.$toast.warn("联系手机格式错误");
        return;
      }
      if (this.legalData) {
        http
          .post(config.saveAuthInfo, {
            idNoFront: this.legalData.idcardIsImg,
            idNoBack: this.legalData.idcardTheImg,
            idNo: this.legalData.methodIdentity,
            userName: this.legalData.methodName,
            bankNo: this.bank_no,
            mobile: this.bank_mobile,
          })
          .then((e) => {
            console.log(e, "1111111");
            if (e.code == 0) {
              const url = "/transferList";
              this.$router.push({ path: url });
            } else {
              this.$toast.warn(e.message);
            }
          });
      }
    },
    consent() {
      this.consentType = !this.consentType;
    },
    yinhangka(e) {
      var that = this;
      let tempFilePaths = e.msg[0];
      that.bankCardIsImg = tempFilePaths;
      // console.log(that.bankCardIsImg,'11111')
      that.uploadFile(tempFilePaths, function (data) {
        if (data) {
          // console.log(data, "6666666666");
          that.bank_no = data.bankCardNumber;
        }
      });
    },
    yinhangka1(e) {
      var that = this;
      let tempFilePaths = e.msg[0];
      that.uploadFile(tempFilePaths, function (url) {
        if (url) {
          console.log(url);
          that.bankCardTheImg = url;
        }
      });
    },
    getUploadConfig() {
      var that = this;
      http.post(config.uploadConfig).then(
        (d) => {
          console.log(d, "阿里接口");
          that.data.d["Bucket"] = d.data.Bucket;
          that.data.d["OSSAccessKeyId"] = d.data.OSSAccessKeyId;
          that.data.d["signature"] = d.data.Signature;
          that.data.d["policy"] = d.data.policy;
          that.data.d["success_action_status"] = d.data.success_action_status;
          that.data.action = d.data.url;
        },
        (err) => {
          //error callback
        }
      );
    },
    uploadFile(filePaths, cb) {
      var fd = new FormData();
      //文件必须声明在最后，否则异常
      fd.append("file", filePaths);
      // console.log(fd.get("file"), "判断是否传进去"); //FormData私有类对象，访问不到，可以通过get判断值是否传进去
      let configed = {
        headers: { "Content-Type": "multipart/form-data" },
      }; //添加请求头
      this.$http.post(config.bankcard, fd, configed).then((res) => {
        if (res.data.code == 0) {
          // console.log(res.data.data, "55555555555");
          if (res.data.data.code == 200) {
            var chars = res.data.data;
            // var result = chars.substring(chars.indexOf('https://gsb-zc.oss-cn-beijing.aliyuncs.com'), chars.indexOf('</Location>'));
            cb(chars);
          } else {
            this.$toast.warn(res.data.data.msg);
          }
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/legalPersonThree/index.vue